<!-- TODO: To be extended to support type info|success|etc. -->

<script setup lang="ts">
import type { AlertProps } from '#ui/types';
import type { PropType } from 'vue';

type MessageType = 'error' | 'info';
type TypeStyle = { color: AlertProps['color']; icon: string };

const { type } = defineProps({
    type: { type: String as PropType<MessageType>, required: true },
    title: { type: String, required: true },
    description: { type: String, default: null },
    actions: { type: Array as PropType<AlertProps['actions']>, default: undefined },
});

const styles: Record<MessageType, TypeStyle> = {
    error: {
        color: 'error',
        icon: 'lucide:circle-x',
    },
    info: {
        color: 'primary',
        icon: 'lucide:info',
    },
};

const style = computed(() => styles[type]);
</script>

<template>
    <UAlert :icon="style.icon" :color="style.color" variant="soft" v-bind="{ title, description, actions }" />
</template>
